export default "__VITE_ASSET__Dfp_Np1C__"